import { useState, useContext } from "react";
import SlideShow from "../Components/Slidehow";
import "D:/REACT PROJECTS/online-adda/src/pages/Home.css"

import HomeSection from "../Components/HomeSection";

function Home(props) {


    const [currObj, setCurrObj] = useState(props.data[1]);







    let index = 0;
    function changeDisplay() {
        setCurrObj(props.data[Math.floor(Math.random() * 20)]);
    }

    setTimeout(changeDisplay, 5000);

    let AllProducts = props.data;
    console.log(AllProducts.length);


    const element = (
        <div className="bg-violet-100 md:pb-10 pb-5 ">
            <div className=" flex  ">

                <div className="min-w-full mx-auto h-fit m-0 flex  justify-center items-center">
                    <SlideShow product={currObj} />
                </div>
            </div>

            <div className=" flex flex-col justify-center lg:gap-10 md:gap-6 gap-2 md:mt-12 mt-6">
                <div className="w-full ">
                    <HomeSection product={props.ElectronicProducts} name="Electronics Section" />
                </div>

                <div className="w-full">
                    <HomeSection product={props.JewelleryProducts} name="Jewellery Section" />
                </div>



                <div className="w-full">
                    <HomeSection product={props.MensProducts} name="Men's Section" />
                </div>

                <div className="w-full">
                    <HomeSection  product={props.WomensProducts} name="Women's Section" />
                </div>

            </div>

        </div>
    );
    return element;
}

export default Home;